<template src="../templates/normal_fcont_205.html" />
<script>
import LabelFunMessage from '../components/LabelFunMessage'

import FuncSearchGalleryQR from '../components/FuncSearchGalleryQR'
import FuncSearchRecommendLink from '../components/FuncSearchRecommendLink'
import PrintButton from '../components/PrintButton'
import ReleaseDateForArticle from '../components/ReleaseDateForArticle'
import InfoMachineTranslation from '../components/InfoMachineTranslation'
import AppDownloadCreative from '../components/AppDownloadCreative'
import AppDownloadPhotoPlus from '../components/AppDownloadPhotoPlus'
import { Carousel,Slide } from 'uiv'

export default {
  name: 'app',
  data() {
    return {
      articleId: '205',
      app_root: process.env.VUE_APP_ROOT
    };
  },
  components: {
    LabelFunMessage, Carousel,Slide,FuncSearchRecommendLink,
    FuncSearchGalleryQR,
    PrintButton,ReleaseDateForArticle,InfoMachineTranslation,AppDownloadCreative,AppDownloadPhotoPlus
  },
  methods: {
    clickInternalLink: function (linkName) {
      // GA4 アンカーリンク
      this.$gtag.event("tap_button", {
        "custom_parameter1": "internal_link",
        "custom_parameter2": linkName
      })
    }
  },
  metaInfo() {
    return {
      title: this.$store.state.messages.messages['205-1'],
      meta: [
        { name: 'description', content: this.$store.state.messages.messages['205-3']}
      ]
    };
  }
  
};
</script>
<style scoped>

h4.title-template{
    margin-top: 30px;
    margin-bottom: 0px;
}

</style>

